<template>
  <router-view></router-view>
</template>
<script>
  export default {

  }
</script>
<style>
  body.white {
    background-color: #ffffff !important;
  }
</style>



// WEBPACK FOOTER //
// Print.vue?0b07c132